export default "__VITE_ASSET__BeVws81R__"